<template>
  <div v-if="oneMenuHideList !== null" class="commonWrap">
    <div v-if="!hideSidebar" class="left">
      <secondaryMenu
        ref="secondaryMenu"
        :route-name="routeName"
        :is-collapse="false"
        :defaultactive="defaultactive"
        :class-obj="classObj"
        permission-key=""
        :project-type="false"
        :externalShowList="externalShowList"
      >
      </secondaryMenu>
    </div>
    <div class="right" :style="{ width: hideSidebar ? '100%' : 'calc(100% - 130px - var(--middle-space))' }">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import secondaryMenu from "@/CommonDP/components/secondaryMenu/secondaryMenu";
import { mapState } from "vuex";
import applicationSettingsService from "@/CommonDP/service/applicationSettings-service";
export default {
  name: "ApplocationCommon",
  components: {
    secondaryMenu
  },
  data() {
    return {
      defaultactive: {
        path: ""
      },
      showSubMenu: true,
      routeName: "",
      oneMenuHideList: null
    };
  },
  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes,
      flatProjectRoutes: (state) => state.router.flatProjectRoutes,
      flatRoutes: (state) => state.router.flatRoutes,
      authProjectRoutes: (state) => state.router.authProjectRoutes,
      userInfo: (state) => state.user.userInfo,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      isShowMyEnterprise: (state) => state.projectMg.isShowMyEnterprise
    }),

    externalShowList() {
      const name = this.$route.matched[2]?.name;
      const meauList = this.flatRoutes.find(({ permissionKey }) => permissionKey === name) || this.flatProjectRoutes.find(({ permissionKey }) => permissionKey === name);
      console.log(meauList.childList, "meauList.childList");

      meauList.sub = meauList.childList.map((item) => {
        item.sub = item.childList || [];
        item.name = item.permissionName;
        item.path = item.location;
        if (item.sub?.length) {
          item.sub.map((item) => {
            item.sub = item.childList || [];
            item.name = item.permissionName;
            item.path = item.location;
          });
        }
        return item;
      });
      meauList.name = meauList.permissionName;
      meauList.path = meauList.location;
      return meauList ? [meauList] : [];
    },

    hideSidebar() {
      return (this.oneMenuHideList && this.externalShowList[0]?.childList?.length === 1) || this.externalShowList[0]?.childList?.length === 0;
    },

    sidebar() {
      return this.$store.state.app.sidebar;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened
      };
    }
  },
  watch: {
    $route(newValue) {
      this.defaultactive.path = this.$route.meta.prouteName;
      this.routeName = this.$route.meta.pname;
    }
  },
  created() {
    this.defaultactive.path = this.$route.meta.prouteName;
    this.routeName = this.$route.meta.pname;
    this.getOneMenuShowChange();
  },
  mounted() {
    this.$refs.secondaryMenu && this.$refs.secondaryMenu.queryNewsNum();
  },
  methods: {
    getOneMenuShowChange() {
      console.log("externalShowList", this.__file, this._uid);
      const appcode = this.externalShowList[0].permissionKey;
      if (appcode) {
        applicationSettingsService.getOnlyChildMemuShowList(appcode).then((res) => {
          this.oneMenuHideList = !!(res.data === 2);
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.commonWrap {
  display: flex;
  width: 100%;
  height: 100%;
  padding: var(--middle-space);

  .left {
    width: 130px;
    // height: calc(100% - 28px);
    background-color: #fff;
    margin-right: var(--middle-space);
  }

  // .right {
  // margin-top: 14px;
  // margin-bottom: 14px;
  // width: calc(100% - 28px);
  // flex: 1;
  // }
}
</style>
